<template>
    <div id="shower-tray-popup" v-bind:style="{display: p_isShowerPopupVisible ? 'block' : 'none'}">
    <div id="shower-popup-content">
      <div class="header">
        <h2 class="configurator-step-headline" >Zus&auml;tzliche Infos zur Rutschhemmung</h2>
        <i @click="hideShowerPopup" class="configurator-stepbar-icon fal fa-times" id="popupCloseButton"></i>
      </div>
      Gepr&uuml;ft durch die Deutsche Gesetzliche Unfallversicherung e.V. (DGUV) erf&uuml;llt das Duschboard das h&ouml;chste Maß an Sicherheit und Standfestigkeit. Alle Dekore besitzen eine bessere Rutschhemmung, als herk&ouml;mmliche Duschwannen.
      <div id="shower-popup-information">

        <div class="shower-popup-information-row">
          <div class="shower-popup-information-column">
            <img src="@/assets/customer/duschking-configurator/shower_tray/popup_save.png" />
          </div>
          <div class="shower-popup-information-column">
            <h2>Save – Maximale Rutschhemmung</h2>
            R11 Rutschhemmung / Klasse B Zertifizierung in der Rutschhemmung Bewertungsgruppe. Die höchste Bewertung, die ein Duschboden erreichen kann. Hiermit ist sogar Pflegepersonal, welche die Dusche mit Schuhen betreten muss, ein absolut sicherer Stand gewährleistet.
          </div>
        </div>
        <div class="shower-popup-information-row">
          <div class="shower-popup-information-column">
            <img src="@/assets/customer/duschking-configurator/shower_tray/popup_slate.png" />
          </div>
          <div class="shower-popup-information-column">
            <h2>Slate – Erhöhte Rutschhemmung</h2>
            Das Duschboard verzeichnet selbst in der niedrigsten Rutschklasse das höchste Maß an Sicherheit und Standfestigkeit. Die Perl Oberfläche besitzt eine bessere Rutschhemmung als herkömmliche Duschwannen und ist somit für die normale, tägliche Anwendung bestens geeignet. 
          </div>
        </div>
        <div class="shower-popup-information-row">
          <div class="shower-popup-information-column">
            <img src="@/assets/customer/duschking-configurator/shower_tray/popup_perl.png" />
          </div>
          <div class="shower-popup-information-column">
            <h2>Perl – Rutschhemmend</h2>
            Das Duschboard verzeichnet selbst in der niedrigsten Rutschklasse das h&ouml;chste Maß an Sicherheit und Standfestigkeit. Die Perl Oberfl&auml;che besitzt eine bessere Rutschhemmung als herk&ouml;mmliche Duschwannen und ist somit f&uuml;r die normale, t&auml;gliche Anwendung bestens geeignet.
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
    props: {
        p_isShowerPopupVisible: {
            default: true,
            type: Boolean,
        },
    },
    methods: {
        hideShowerPopup() {
            this.$parent.hidePopup();
        },
    }
};
</script>


// WEBPACK FOOTER //
// src/components/customer/duschking-konfigurator/ShowerPopup.vue